module.exports = __webpack_public_path__ + "6d08919dcfa25d0c06bccc05e2e7891b.jpg";